module.exports = __webpack_public_path__ + "static/img/page3.512670f8.png";